import { ThemeProperties } from "../theme.types";
import breakpoints from "../tokens/breakpoints";

export const uglaTheme: ThemeProperties = {
  name: "ugla",
  title: "UGLA VAB Viewer",

  assets: {
    favicon: "/themes/ugla/favicon.png",
  },

  gradients: {
    headerBackground:
      "linear-gradient(180deg, #0B2A63, #0164AB 50%, #0B2A63 100%)",
  },

  breakpoints: breakpoints,
};
